import { OrderLine } from './';
import { LineStatus } from './enums';

export class OrderLineGroup {
  public status: LineStatus;
  public orderLines: OrderLine[];
}
